<template>
  <div
      class="container-fluid files-list-overflow"
      style="max-width: 1300px;"
  >
  <div class="card w-100">
    <div class="card-header view">
      <div class="header">
        <div class="title">
          <div>Upload Studies</div>
        </div>
        <div class="steps">
          <el-steps :active="0" finish-status="success">
            <el-step title="Step 1"></el-step>
            <el-step title="Step 2"></el-step>
          </el-steps>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="form-wrapper">
        <div class="w-50 ml-auto mr-auto p-4">
          <div class="w-100 d-flex">
            <div class="col-div">
              <div class="label-div">
                <label>Client</label>
              </div>
              <el-select
                v-model="formData.client"
                class="type-input w-100"
                filterable
                collapse-tags
              >
                <el-option-group label="Press Tab/Escape to exit">
                  <el-option
                    v-for="client in clientsToPick"
                    :key="client.value" :label="client.value" :value="client.value"
                  >
                  </el-option>
                </el-option-group>
              </el-select>
            </div>
            <div class="col-div">
<!--              <div class="label-div">-->
<!--                <label>Study Type</label>-->
<!--              </div>-->
<!--              <el-select-->
<!--                class="type-input w-100"-->
<!--                v-model="formData.study_type"-->
<!--              >-->
<!--                <el-option-group label="Press Tab/Escape to exit">-->
<!--                  <el-option-->
<!--                    key="study" label="study" value="study">-->
<!--                  </el-option>-->
<!--                </el-option-group>-->
<!--              </el-select>-->
            </div>
          </div>
          <div class="w-100 d-flex">
            <div class="col-div">
              <div class="label-div">
                <label>Region</label>
              </div>
              <el-select
                class="type-input w-100"
                v-model="formData.region"
                filterable
                collapse-tags
              >
                <el-option-group label="Press Tab/Escape to exit">
                  <el-option
                    v-for="region in regionsToPick"
                    :key="region.value" :label="region.value" :value="region.value"
                  >
                  </el-option>
                </el-option-group>
              </el-select>
            </div>
            <div class="col-div">
              <div class="label-div">
                <label>Year</label>
              </div>
              <el-select
                class="type-input w-100"
                v-model="formData.year"
                filterable
                collapse-tags
              >
                <el-option-group label="Press Tab/Escape to exit">
                  <el-option
                    v-for="year in yearsToPick"
                    :key="year" :label="year" :value="year"
                  />
                </el-option-group>
              </el-select>
            </div>
          </div>
          <div class="w-100 file-input custom-padding">
            <div class="w-100 text-center">
              <el-upload
                class="upload-file el-upload-input-custom-styles"
                :ref="`upload`"
                :show-file-list="false"
                :on-change="(f, flist) => handleChange(f)"
                :auto-upload="false"
              >
                <el-input
                  v-model="fileNames"
                  class="el-input-upload"
                  placeholder="Select or drop zip file" clearable
                >
                  <div slot="append" class="el-input-upload-icon-div w-100">
                      <font-awesome-icon
                        class="el-input-upload-icon"
                        :style="{'background-color': status.background}"
                        :icon="status.icon" color="white"
                      />
                  </div>
                </el-input>
              </el-upload>
            </div>
          </div>
          <div class="w-100 text-center">
            <button
              v-if="fileList.length"
              class="clear-files-btn mr-1"
              @click="handleClearFiles"
            >
              Clear files
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-end">
        <button
          class="btn next-button"
          @click="handleSubmitFiles"
          :disabled="!fileList.length"
        >
          Next
        </button>
      </div>
      <div class="w-100 mt-2">
        <StudiesUploadHistory
          :table-data="fileProcessList"
          :go-to-file-process-details="goToFileProcessDetails"
        />
      </div>
    </div>
  </div>
    </div>
</template>

<script>
import StudiesUploadHistory
from '@/components/StudiesUpload/StudiesUploadHistory'

export default {
  name: 'StudiesUploadFirstStep',
  components: {
    StudiesUploadHistory
  },
  props: {
    'fileNames': String,
    'status': Object,
    'handleChange': Function,
    'handleSuccess': Function,
    'handleClearFiles': Function,
    'handleSubmitFiles': Function,
    'fileList': Array,
    'yearsToPick': Array,
    'clientsToPick': Array,
    'regionsToPick': Array,
    'formData': Object,
    fileProcessList: Array,
    goToFileProcessDetails: Function
  }
}
</script>

<style lang="scss">
@import '../../assets/scss/variables';
.el-upload-input-custom-styles {
  .el-upload {
    width: 100%;
    .el-input-upload {
      input.el-input__inner {
        pointer-events: none;
        height: 48px;
      }
      div.el-input-group__append {
        width: 100px;

        .el-input-upload-icon-div {
          width: 100%;
          padding: 0;

          button.el-button {
            padding: 10px 0 !important;
            width: 100%;

            span {
              svg {
                width: 100%;
                padding: 5px 0;
                margin: 0 !important;
                border-radius: 0.2rem;
              }
            }
          }
        }
      }
    }
  }
}

</style>
<style lang="scss" scoped>
@import '../../assets/scss/variables';
.custom-padding {
  padding: 2rem 1rem !important;
}

.files-list-overflow {
  overflow-x: hidden;
  overflow-y: scroll;
}
.next-button {
  font-family: 'Open Sans', sans-serif;
  font-weight: 900;
  font-size: 16px;
  line-height: 30px;
  letter-spacing: 0;
  background-color: $blueberry;
  color: white;
  text-transform: uppercase;
  border-radius: 4px;
  width: 160px;
  height: 38px;
  padding: 5px;
  @media screen and (min-width: $break-lg) {
    width: 180px;
    height: 40px;
    padding: 2px;
  }
  @media screen and (min-width: $break-xl) {
    width: 200px;
    height: 42px
  }
  @media screen and (min-width: $break-xxl) {
    width: 240px;
    height: 44px
  }
  transition: background-color 0.2s linear;
  &:hover {
    background-color: #9256D9;
  }
}

div.col-div {
  padding: 1rem;
  width: 55%;

  div.label-div {
    width: 100%;

    label {
      font-size: 22px;
    }
  }
}

.file-input {
  padding: 2rem;
  text-align: center;

  ::v-deep .upload-file {
    width: 100%;

  .el-input__inner {
    border-right: 0 !important;
  }

  .el-input-group__append {
    background-color: rgb(59, 134, 255) !important;
    cursor: pointer;
    padding: 0 !important;
    border: 0 !important;

    div {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      padding: 1px 8px;
      height: 100%;

      button {
        padding: 10px !important;
      }
    }
  }
}
}

.clear-files-btn, .send-files-btn {
  border: none;
  font-size: 20px;
  background: transparent;
  padding: .25rem .5rem;
  transition: .5s;
  border-radius: 10px;
}
.clear-files-btn:hover {
  background: $red-700;
  color: $soft-blue;
}
.send-files-btn:hover {
  background: $blue-400;
  color: $soft-blue;
}

.el-input-upload-icon {
  font-size: 38px;
  margin: 0 5px;
}

.card {
  margin-bottom: 0;
  border: 0;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.93);
  max-width: 1300px;
}

.view {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  padding: 0;
  padding-bottom: 1rem;

  .header {
    display: flex;
    justify-content: space-between;

    .steps {
      width: 270px;
      height: 62px;
      margin-top: 20px;
      margin-right: 29px;
    }
  }

  .form-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 600;
    font-size: 20px;
    line-height: 33px;
    @media screen and (min-width: $break-lg) {
      font-size: 20px;
      line-height: 38px;
    }
    @media screen and (min-width: $break-xl) {
      font-size: 24px;
      line-height: 43px;
    }
    @media screen and (min-width: $break-xxl) {
      font-size: 28px;
      line-height: 48px;
    }
    letter-spacing: 0;
    color: $dusty-blue;
    margin: 20px 0;
    @media screen and (min-width: $break-lg) {
      margin: 30px 0
    }
    @media screen and (min-width: $break-xl) {
      margin: 45px 0
    }
    @media screen and (min-width: $break-xxl) {
      margin: 60px 0
    }

    .type-input {
      margin-left: 20px;
      height: 43px !important;
      @media screen and (min-width: $break-lg) {
        height: 47px;
      }
      @media screen and (min-width: $break-xl) {
        height: 51px;
      }
      @media screen and (min-width: $break-xxl) {
        height: 55px;
      }
    }
  }
}

.title {
  margin-top: 20px;
  margin-left: 32px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 900;
  font-size: 30px;
  line-height: 24px;
  letter-spacing: 0.8px;
  @media screen and (min-width: $break-lg) {
    font-size: 35px;
    line-height: 26px;
    letter-spacing: 0.8px;
    margin-top: 23px;
    margin-left: 37px;
  }
  @media screen and (min-width: $break-xl) {
    font-size: 40px;
    line-height: 28px;
    letter-spacing: 0.9px;
    margin-top: 26px;
    margin-left: 42px;
  }
  @media screen and (min-width: $break-xxl) {
    font-size: 45px;
    line-height: 30px;
    letter-spacing: 0.9px;
    margin-top: 29px;
    margin-left: 47px;
  }
  color: $pewter;
  text-transform: uppercase;
}

.title svg {
  margin-right: 0.5em;
}

.upload-file {
  .el-input__inner {
    border-right: 0 !important;
  }

  .el-input-group__append {
    color: white !important;
    cursor: pointer;
    padding: 0 !important;
    border: 0 !important;

    div {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      padding: 1px 8px;
      height: 100%;

      button {
        padding: 10px !important;
      }
    }
  }
}
</style>
